// Yandex's Conversations API has no "list conversations" endpoint, so this app owns the list
// of threads for a user entirely — id, name, createdAt and lastMessageAt all live in
// localStorage, nothing is validated against the server.

const STALE_THREAD_MAX_AGE_MS = 3 * 24 * 60 * 60 * 1000; // 3 days

function storageKey(userName) {
  return `THREADS_${userName}`;
}

export function getThreads(userName) {
  try {
    const raw = localStorage.getItem(storageKey(userName));
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    console.error('Ошибка чтения списка чатов из localStorage:', e);
    return [];
  }
}

export function saveThreads(userName, threads) {
  localStorage.setItem(storageKey(userName), JSON.stringify(threads));
}

export function addThread(userName, thread) {
  const threads = getThreads(userName).filter(t => t.id !== thread.id);
  const now = new Date().toISOString();
  threads.unshift({
    id: thread.id,
    name: thread.name,
    createdAt: thread.createdAt || now,
    lastMessageAt: thread.lastMessageAt || thread.createdAt || now,
  });
  saveThreads(userName, threads);
}

export function updateThread(userName, threadId, patch) {
  const threads = getThreads(userName);
  const idx = threads.findIndex(t => t.id === threadId);
  if (idx !== -1) {
    threads[idx] = { ...threads[idx], ...patch };
    saveThreads(userName, threads);
  }
}

// Call whenever the user sends a message in a thread, so pruneStaleThreads knows it's still active.
export function touchThread(userName, threadId) {
  updateThread(userName, threadId, { lastMessageAt: new Date().toISOString() });
}

export function removeThread(userName, threadId) {
  saveThreads(userName, getThreads(userName).filter(t => t.id !== threadId));
}

// Drops threads with no activity for 3+ days from localStorage and returns the removed ones,
// so the caller can also delete them server-side / log it without blocking the UI on it.
export function pruneStaleThreads(userName) {
  const threads = getThreads(userName);
  const now = Date.now();
  const nowIso = new Date(now).toISOString();

  // Threads saved before lastMessageAt was tracked have no such field — falling back to their
  // (possibly old) createdAt would wrongly mark real, still-used conversations as stale on the
  // first load after this feature shipped. Treat "unknown" as "active now" instead, and migrate
  // it in place so future prunes have real data to work with.
  let migrated = false;
  const stale = [];
  const fresh = threads
    .map(t => {
      if (!t.lastMessageAt) {
        migrated = true;
        return { ...t, lastMessageAt: nowIso };
      }
      return t;
    })
    .filter(t => {
      const isStale = now - new Date(t.lastMessageAt).getTime() > STALE_THREAD_MAX_AGE_MS;
      if (isStale) stale.push(t);
      return !isStale;
    });

  if (stale.length > 0 || migrated) {
    saveThreads(userName, fresh);
  }

  return stale;
}



// WEBPACK FOOTER //
// ./src/components/api/thread-storage.js